import register from "preact-custom-element";
import { HeaderToolTip } from "./headerToolTip";

export const bootstrapHeaderToolTip = () => {
  register(HeaderToolTip, "ice-header-tooltip", ["text", "buttonId", "isWebcomponent", "delay"], { shadow: false });
};
